import styled from 'styled-components';

export const SliderContainer = styled.div`
  margin: 0 auto;
  width: 65%;
  max-width: 900px;
`;

export const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const LargeImage = styled.img`
  width: 100%;
  margin: 5% auto;
`;
